import sdl from '@jds/react-generated-sdl/JDSSkeleton';
import type { JDSSkeletonProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, SkeletonProps } from '../logic';

const Component = (props: SkeletonProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    shape = 'circle',
    animated = false,
    _ariaBusy = props.animated?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { shape, animated, _ariaBusy, ...rest },
    'JDSSkeleton',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Skeleton = withLogic(Component) as React.FC<SkeletonProps> & {
  slotName?: string;
};

Skeleton.displayName = 'Skeleton';
Skeleton.slotName = 'jds_skeleton';

export { Skeleton, type JDSSkeletonProps };
